// extracted by mini-css-extract-plugin
var _1 = "ChapterPathBackgroundRoofline__chapterPathBackgroundRoofline--SsgO2";
var _2 = "ChapterPathBackgroundRoofline__img--Hlnd3 ChapterPathStyles__antiSeams--XNFsH ChapterPathStyles__antiLag--A6PV1";
export { _1 as "chapterPathBackgroundRoofline", _2 as "img" }
